<div class="modal-header">
  <h4 class="modal-title">Изтриване на профила</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <div class="alert alert-danger">
    Изтриването на профила ще премахне всички данни, свързани с вашия акаунт, включително лична информация и настройки. Този процес е необратим и
    данните не могат да бъдат възстановени.
    <strong>Сигурни ли сте, че искате да продължите?</strong>
  </div>
  <form [formGroup]="form">
    <fieldset class="mb-3">
      <label for="password" class="mb-0 form-label">Парола*</label>
      <input
        id="password"
        type="password"
        formControlName="password"
        class="form-control"
        placeholder="Въведете парола..."
        aria-label="Парола"
        [class.is-valid]="password?.touched && password?.valid"
        [class.is-invalid]="password?.touched && password?.invalid">
      <p class="invalid-feedback m-0">Задължително поле!</p>
    </fieldset>
  </form>
  @if (!!errorMessage) {
    <div class="pb-2 text-danger">
      {{ errorMessage }}
    </div>
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
